import { UrlConstants } from "../url.constants";
export class ApiAdminConstants {
    static URL = UrlConstants.API_V2 + "Admin";
    static FUNCTION_SEND_MESSAGE_TO_ALL = "SendMessageToAll";
    static FUNCTION_SEND_MESSAGE_TO_ORGANISATION = "SendMessageToOrganisation";
    static FUNCTION_SEND_MESSAGE_TO_MODULE = "SendMessageToModule";
    static FUNCTION_SEND_MESSAGE_TO_USER = "SendMessageToUser";
    static FUNCTION_SEND_FEEDBACK_TO_AFLA = "SendFeedbackEmail";
    static FUNCTION_IS_APPLICATION_CLOSED = "IsApplicationClosed";
}
